<template>
  <v-container>
    <v-snackbar
      class="snackbar-top"
      v-model="notification.show"
      :top="true"
      :right="true"
      :color="notification.color"
    >
      {{ notification.message }}
      <v-btn
        fab small outlined
        @click="closeNotification"
      >
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>

    <v-row
      justify="center">
      <v-col cols="12" md="7">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ $t('forms.settings.titles.home') }}
          </v-card-title>
          <v-card-text>
            <v-alert type="error" dismissible v-if="error" class="mt-5">{{error}}</v-alert>
            <v-alert type="success" dismissible v-if="notice" class="mt-5">{{notice}}</v-alert>
            <v-form ref="form" v-model="valid" class="pt-2">

              <v-row>
                <v-col cols="6" class="py-0">
                  <v-checkbox
                  on-icon="check_circle_outline"
                  off-icon="radio_button_unchecked"
                  v-model="settings.show_video"
                  :label="$t('forms.settings.home.show-video')"
                  ></v-checkbox>
                </v-col>
                <v-col cols="6" v-if="settings.show_video" class="py-0">
                  <v-select
                  outlined
                  :label="$t('forms.video')"
                  v-model="settings.video"
                  :items="videos"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.video')})]"
                  required
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="py-0">
                  <v-checkbox
                  on-icon="check_circle_outline"
                  off-icon="radio_button_unchecked"
                  v-model="settings.show_button"
                  :label="$t('forms.settings.home.show-button')"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row v-if="settings.show_button">
                <v-col cols="4" class="py-0">
                  <v-select
                  outlined
                  :label="$t('forms.settings.home.button-type')"
                  v-model="settings.button_type"
                  :items="button_types"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.settings.home.button-type')})]"
                  v-on:change="changeButtonType"
                  required
                  ></v-select>
                </v-col>
                <v-col cols="4" class="py-0">
                  <v-select
                  outlined
                  :label="$t('forms.settings.home.button-url')"
                  v-model="settings.button_url"
                  :items="button_urls"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.settings.home.button-url')})]"
                  required
                  ></v-select>
                </v-col>
                <v-col cols="4" class="py-0">
                  <v-text-field
                  outlined
                  :label="$t('forms.settings.home.button-text')"
                  type="text"
                  v-model="settings.button_text"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.settings.home.button-text')})]"
                  required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                  outlined
                  :label="$t('forms.settings.home.title')"
                  type="text"
                  v-model="settings.title"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="py-0">
                  <v-textarea
                  outlined
                  :label="$t('forms.settings.home.description')"
                  v-model="settings.description"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="py-0">
                  <v-checkbox
                  on-icon="check_circle_outline"
                  off-icon="radio_button_unchecked"
                  v-model="settings.show_components"
                  :label="$t('forms.settings.home.show-components')"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-checkbox
                  on-icon="check_circle_outline"
                  off-icon="radio_button_unchecked"
                  v-model="settings.show_news"
                  :label="$t('forms.settings.home.show-news')"
                  ></v-checkbox>
                </v-col>
                <v-col cols="6" v-if="settings.show_news" class="py-0">
                  <v-select
                  :label="$t('forms.settings.home.news-days')"
                  v-model="settings.news_days"
                  :items="getNewsDays()"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.settings.home.news-days')})]"
                  required
                  ></v-select>
                </v-col>
            </v-row>

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveSettings" :loading="loading" :disabled="loading">
            {{$t('forms.save')}}
            <template v-slot:loader>
              <span>{{$t('forms.loading-save')}}</span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>

      </v-col>
    </v-row>

    <v-overlay :value="loading_page">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<style lang="scss">
  .v-snack--top {
      top: 5em !important;
  }
</style>

<script>
import * as service from '@/store/module/settings'
// import { getUrlImage } from '@/store/storage'

export default {
  data() {
    return {
      videos: [],
      categories: [],
      valid: false,
      loading: false,
      loading_page: false,
      error: null,
      notice: null,
      notification: {
        color: 'gree',
        show: false,
        message: ''
      },
      settings: {
        show_video: false,
        video: null,
        title: '',
        description: '',
        show_components: false,
        show_news: false,
        news_days: 0,
        show_button: false,
        button_type: null,
        button_text: '',
        button_url: null
      },
      button_types: [
        { id: 'video', name: this.$t('forms.video') },
        { id: 'category', name: this.$t('forms.category') }
      ],
      button_urls: []
    }
  },
  created() {
    this.loadVideos()
    this.loadCategories()
    this.loadSettings()
  },
  methods: {
    showNotification(success, message) {
      this.notification.message = message
      this.notification.color = success ? 'green' : 'red'
      this.notification.show = true
    },
    closeNotification() {
      this.notification.show = false
      this.notification.message = ''
    },
    loadVideos() {
      service.getDocumentsFromCollection('videos').then(result => {
        this.videos = result
      })
    },
    loadCategories() {
      service.getDocumentsFromCollection('categories').then(result => {
        this.categories = result
      })
    },
    changeButtonType() {
      this.button_urls = this.settings.button_type === 'video' ? this.videos : this.categories
    },
    getNewsDays() {
      let days = []
      for (let i = 1; i < 30; i++) {
        days.push(i)
      }
      return days
    },
    loadSettings() {
      this.loading_page = true
      service.getHomeSettings()
      .then(settings => {
        this.settings = settings
        this.changeButtonType()
        this.loading_page = false
      })
      .catch(error => {
        this.error = error.message
      })
    },
    saveSettings() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.notice = null
        this.error = null

        service.saveHomeSetting(this.settings)
        .then(() => {
          this.showNotification(true, this.$t("forms.saved-record"))
          this.loading = false
        })
        .catch(error => {
          this.error = error.message
          this.loading = false
        })
      }
    }
  }
}
</script>
